import { createFetch } from '@vueuse/core'
import { defineStore } from 'pinia'

import router from '@/router'
import { useAppStore } from '@/stores/app'

export const useFetchStore = defineStore('fetch', () => {
    const appStore = useAppStore()

    const fetch = createFetch({
        baseUrl: '/api/user/v1',
        options: {
            updateDataOnError: true,
            beforeFetch({ options }) {
                options.headers = new Headers(options.headers)
                const JWT = appStore.getJWT()
                if (JWT.length > 0) options.headers.set('Authorization', `Bearer ${JWT}`)
                return { options }
            },
            async onFetchError(ctx) {
                if (ctx.response && ctx.response.status === 401) {
                    appStore.setLogout()
                    await router.push({ name: 'login' })
                }
                return ctx
            }
        }
    })

    return {
        fetch
    }
})
